export const CONTENT_TYPE_TEXT = "text"
export const CONTENT_TYPE_HTML = "html"
export const CONTENT_TYPE_IMAGE = "image"
export const CONTENT_TYPE_OPTIMISE_IMAGE = "optimise_image"

export const CONTENT_TYPES = [CONTENT_TYPE_TEXT, CONTENT_TYPE_HTML, CONTENT_TYPE_IMAGE, CONTENT_TYPE_OPTIMISE_IMAGE]

import find from 'lodash/find'
import get from 'lodash/get'

const extractContent = (contentID, contentType, data) => {
  const node = find(data, node => {
    return node.node.contentfulid === contentID
  })

  if (!node) {
    console.debug('Node', contentID, 'not found')
    return null
  }

  if (contentType === CONTENT_TYPE_TEXT) {
    return node.node.contentText.contentText
  }

  if (contentType === CONTENT_TYPE_HTML) {
    return node.node.contentText.childMarkdownRemark.html
  }

  if (contentType === CONTENT_TYPE_IMAGE) {
    return get(node, 'node.contentImage.0.file.url', null)
  }

  if (contentType === CONTENT_TYPE_OPTIMISE_IMAGE) {
    return get(node, 'node.contentImage.0.resolutions', null)
  }
}

export default extractContent


// WEBPACK FOOTER //
// ./src/helpers/extractContent.js